import {
  isNumber,
  isDate,
  type Validation,
} from './utils';

const validations: Validation[] = [
  ({ transactionDate }) => isDate(transactionDate) || { transactionDate: 'Transaction date should be a valid date.' },
  ({ amount }) => isNumber(amount) || { amount: 'Amount should be a valid number.' },
  ({ amount }) => {
    if (!isNumber(amount)) {
      return true;
    }
    return Number(amount) > 0 || { amount: 'Amount must be greater than 0.' };
  },
];

const KEYS = [
  'transactionDate',
  'amount',
  'paymentMethod',
  'notes',
  'items',
];

export {
  validations,
  KEYS,
};
